import type { MultiplesGeneratorCommandFactory } from '../MultiplesGeneratorModel';

/**
 * Example of a command model command
 *
 * This is just a simple commands with no arguments and not executing other commands.
 */
export const generateMultiplier: MultiplesGeneratorCommandFactory =
  (cmdContext) => () => {
    cmdContext.updateState((draft) => {
      draft.multiplier = cmdContext.generateRandomNumber();
    });
  };
